// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__8nNSi","modalClose":"style_modalClose__RIO7N","content":"style_content__cXZGo","titlePic":"style_titlePic__f8t6s","text":"style_text__wm8es"};